export default {
  menuItems: {
    selectAll: {
      tooltip: "全選 (ctrl+A/command+A)",
    },
    verticalArrange: {
      tooltip: "縱向排列（只支持單列）",
    },
    backToCenter: {
      tooltip: "回到中心",
    },
    previousStep: {
      tooltip: "上一步 (ctrl+Z/command+Z)",
    },
    nextStep: {
      tooltip: "下一步 (ctrl+F/command+F)",
    },
    shortcutKeys: {
      tooltip: "使用者幫助",
    },
    addressExpand: {
      tooltip: "地址展開",
    },
    addressCollapse: {
      tooltip: "地址收起",
    },
  },
};
